import React, { useEffect, useState } from "react";
import "./AwardsRecognition.css";

import award1 from "../Component/awardrecognition1.jpg";
import award2 from "../Component/Ack-1.jpg";
import award3 from "../Component/awardrecognition3.jpg";
import award4 from "../Component/Ack-2.jpg";

export default function AwardsRecognition() {
  const images = [ award1, award2, award3, award4];
  const [index, setIndex] = useState(0);

  // Auto-slide every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <div className="awards-container" style={{ paddingTop: 0 }}>

      {/* ===== Banner Slider ===== */}
      <div className="banner-slider">
        <div
          className="slider-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {images.map((img, i) => (
            <div key={i} className="banner-img-wrapper">
              <img src={img} alt="Awards Banner" className="banner-img" />
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="dots">
          {images.map((_, i) => (
            <span
              key={i}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => setIndex(i)}
            ></span>
          ))}
        </div>
      </div>

      {/* ===== Content Section ===== */}
      <div className="content-section">
        <h2>Awards & Recognitions</h2>

        <p>
          Over the years, our organization has been honored with numerous awards
          and recognitions for excellence, innovation, and unwavering
          commitment to quality. Each award reflects the passion, dedication,
          and hard work that our team consistently delivers.
        </p>

        <p>
          We strongly believe that true achievement is the outcome of teamwork,
          discipline, and a continuous pursuit of improvement. With this belief,
          our members strive to transform every challenge into an opportunity
          for growth and learning.
        </p>

        <p>
          Our contributions in education, training, leadership development, and
          community engagement have earned recognition from several prestigious
          national and international organizations. These honors motivate us to
          continuously raise our standards.
        </p>

        <p>
          Our goal has never been limited to receiving awards but to set
          benchmarks that inspire future generations. We aim to create an
          environment where excellence is encouraged, celebrated, and nurtured.
        </p>

        <p>
          Through these achievements, we have been able to implement new ideas,
          embrace modern approaches, and enhance the overall impact of our
          services. This journey of growth helps us serve our stakeholders
          better each day.
        </p>

        <p>
          Looking ahead, we remain committed to excellence and innovation.
          With every step forward, we aim to contribute positively not only to
          our organization but to the community at large.
        </p>

        <p>
          We take pride in our team and students who consistently uphold the
          spirit of dedication and excellence. Their determination continues to
          drive us toward greater milestones.
        </p>
      </div>
    </div>
  );
}